import '../styles/forms/forms.scss';
// libs
//-------------------------------------------------------
window.$ = require('jquery');

window.jQuery = window.$;

require('./libs/index');

//-------------------------------------------------------
$(() => {
    var iframe = $('.js-iframe', parent.document.body);
    iframe.height($(document.body).height() + 50);


	var selectInit = function selectInit() {
	  var maxHeight = 300;
	  $('.js-select').each(function sInit() {
	    var $this = $(this);
	    if ($this.hasClass('select-inited')) return;
	    $this.select2({
	      width: $this.data('width') || '100%',
	      theme: $this.data('theme') || 'custom-select2',
	      minimumResultsForSearch: -1,
	      dropdownAutoWidth: true
	    });
	    $this.addClass('select-inited');
	    $this.on('select2:open', function () {
	      // TODO: fix select2 vs nanoscroller height
	      setTimeout(function () {
	        var $selectOptions = $('.select2-results__options');
	        if ($selectOptions.height() <= maxHeight) return;
	        $selectOptions.addClass('nano-content').parent().addClass('nano').nanoScroller({
	          alwaysVisible: true
	        });
	      }, 0);
	    });
	  });
	}; // generate select from btn-group
	//-------------------------------------------------------------------------------


	var selectBtnGroupInit = function selectBtnGroupInit() {
	  var generateSelect = function generateSelect(items) {
	    var selectHtml = ['<div class="select-label"><select class="js-select">'];

	    for (var i = 0; i < items.length; i++) {
	      selectHtml.push("<option value=\"".concat(items[i].link, "\">").concat(items[i].text, "</option>"));
	    }

	    selectHtml.push('</select>');
	    return selectHtml.join('');
	  };

	  var pasteBtnGroup = function pasteBtnGroup(btnsHtml, $container) {
	    $container.html(btnsHtml);
	    $container.removeClass('btn-group-select');
	  };

	  var pasteSelect = function pasteSelect($container, btnArray) {
	    $container.html(generateSelect(btnArray));
	    $container.addClass('btn-group-select');
	    selectInit();
	  };

	  $('.js-group-btn-select').each(function sgInit() {
	    var $this = $(this);
	    var btnHtml = $this.html();
	    var $btns = $this.find('.btn');
	    var btnArray = [];
	    var isBtnHtml = null;
	    $btns.each(function btEach() {
	      var btnThis = $(this);
	      btnArray.push({
	        link: btnThis.data('link'),
	        text: btnThis.html()
	      });
	    });

	    if (_index.default.viewport.isMobile) {
	      pasteSelect($this, btnArray);
	      isBtnHtml = false;
	    } else {
	      isBtnHtml = true;
	    }

	    _index.default.$window.resize(function () {
	      if (_index.default.viewport.isMobile && isBtnHtml) {
	        pasteSelect($this, btnArray);
	        isBtnHtml = false;
	      }

	      if (!_index.default.viewport.isMobile && !isBtnHtml) {
	        pasteBtnGroup(btnHtml, $this);
	        isBtnHtml = true;
	      }
	    });
	  });
	};

	selectInit();
	selectBtnGroupInit();

	
	$('.js-datepicker').each(function dateInit() {
	    const $this = $(this);

	    const options = {
	      range: !!$this.data('range'),
	      classes: $this.data('style'),
	      dateFormat: 'd M',
	      multipleDatesSeparator: ' - ',
	      onSelect: (formattedDate, date, inst) => {
	        console.log(inst);
	      },
	    };

	    $this.datepicker(options);
	});

	$('.js-add-file').on('click', function() {
		$('.js-add-file-input').click();
	});

	$('.js-add-select').on('click', function() {
		var count = 0;
		
		$('.js-form__block .form__block').each(function(){
			count = count + 1;
			return count;
		})

		if (count < 2) {
			$('.js-form__block').append('<div class="form__block"><select class="search-select js-select"><option value="Аэропорт первой посадки *">Аэропорт первой посадки *</option><option value="Завтра, 3 марта">Завтра, 3 марта</option><option value="Завтра, 3 марта">4 марта</option><option value="Завтра, 3 марта">5 марта</option><option value="Завтра, 3 марта">6 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option></select></div>');
			selectInit();
			selectBtnGroupInit();

		    var iframe = $('.js-iframe', parent.document.body);
		    iframe.height($(document.body).height() + 50);
		} 


		if (count == 1) {
			$(this).css('display','none');
		}

		return false;
	});

	$('.js-add-form__table-inner').on('click', function() {
		$('.js-form__table-block').append('<div class="form__table-inner"><div class="form__table-element form__table-element--first"><select class="search-select js-select"><option value="1 класс">1 класс</option><option value="Завтра, 3 марта">Завтра, 3 марта</option><option value="Завтра, 3 марта">4 марта</option><option value="Завтра, 3 марта">5 марта</option><option value="Завтра, 3 марта">6 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option></select></div><div class="form__table-element form__table-element--second"><select class="search-select js-select"><option value="1 класс"></option><option value="Завтра, 3 марта">Завтра, 3 марта</option><option value="Завтра, 3 марта">4 марта</option><option value="Завтра, 3 марта">5 марта</option><option value="Завтра, 3 марта">6 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option></select></div><div class="form__table-element form__table-element--third"><input type="number" name="" placeholder="" min="0" class="js-count-place"></div><div class="form__table-element form__table-element--fourth"><input type="number" name="" placeholder="" min="0" class="js-weight"></div><div class="form__table-element form__table-element--fifth"><select class="search-select js-select"><option value="паллет">паллет</option><option value="Завтра, 3 марта">Завтра, 3 марта</option><option value="Завтра, 3 марта">4 марта</option><option value="Завтра, 3 марта">5 марта</option><option value="Завтра, 3 марта">6 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option><option value="Завтра, 3 марта">7 марта</option></select></div><div class="form__table-element form__table-element--sixth form__table-element--exc"><div class="js-amount"><span><input type="number" name="" placeholder="" min="0" class="js-long"></span><span><input type="number" name="" placeholder="" min="0" class="js-width"></span><span><input type="number" name="" placeholder="" min="0" class="js-height"></span></div></div></div>');
		selectInit();
		selectBtnGroupInit();

	    var iframe = $('.js-iframe', parent.document.body);
	    iframe.height($(document.body).height() + 50);
	    
		return false;
	});

	$('.js-count-place').on('input', function() {
		var main = 0;
		$('.js-count-place').each(function(){
			if ($(this).val() > 0) {
				main = main + parseInt($(this).val());
			}
		});

		$('.js-count-place-main').html(main);
	})

	$('.js-weight').on('input', function() {
		var main = 0;
		$('.js-weight').each(function(){
			if ($(this).val() > 0) {
				main = main + parseInt($(this).val());
			}
		});

		$('.js-weight-main').html(main);
	});

	$('.js-amount input').on('input', function() {
		var	allsum = 0;
		$('.js-amount').each(function(){
			var sum = 0,
				long   = (parseInt($(this).find('.js-long').val()) * 0.01),
				width  = (parseInt($(this).find('.js-width').val()) * 0.01),
				height = (parseInt($(this).find('.js-height').val()) * 0.01);

			if (long < 0.01 || isNaN(long)) {
				long = 0.01;
			}

			if (width < 0.01 || isNaN(width)) {
				width = 0.01;
			}

			if (height < 0.01 || isNaN(height)) {
				height = 0.01;
			}

			sum = (long * width * height);
			console.log(123);
			allsum = allsum + sum;
		});

		$('.js-amount-main').html(allsum.toFixed(6)-0);
	});

	$('.js-password-img').on('click', function(){
		var element = $('.js-password');

		$(this).toggleClass('password-img--active')

		if (element.attr('type') == 'password') {
			element.attr('type', 'text');
		} else {
			element.attr('type', 'password');
		}
	});

	if ($('.tab_content').length > 0) {
		$(".tab_content").hide(); //Hide all content
	    $("ul.tabs li:first").addClass("active").show().find("label input:radio").attr("checked",""); //Activate first tab
	    $(".tab_content:first").show(); //Show first tab content

	    //On Click Event
	    $("ul.tabs li").click(function() {
	        $("ul.tabs li").removeClass("active"); //Remove any "active" class
	        $("ul.tabs li").find("label input:radio").attr("checked",false);
	        $(this).addClass("active").find("label input:radio").attr("checked",true);
	        $(".tab_content").hide(); //Hide all tab content
	        var activeTab = $(this).find("label input:radio").val(); //Find the href attribute value to identify the active tab + content
	        $('#' + activeTab).fadeIn(); //Fade in the active ID content
	        return false;
	    });
	}

    $('.js-inn').on('click', function(){
    	$(window.top.document).find('html, body').animate({ scrollTop: $(window.top.document).find('iframe').offset().top - 40 }, 500);
		$(this).blur();
		$('.form-inn').addClass('form-inn--active');
		$(window.top.document).find('body').css('overflow', 'hidden');
		$('.form-inn').css('overflow', 'auto');
		return false;
    });

    $('.js-section-back-btn').on('click', function(){
		$('.form-inn').removeClass('form-inn--active');
		$(window.top.document).find('body').css('overflow', 'auto');
		$('.form-inn').css('overflow', 'hidden');
		return false;
    });

    $('.js-close').on('click', function(){
		$('.form-inn').removeClass('form-inn--active');
		$(window.top.document).find('body').css('overflow', 'auto');
		$('.form-inn').css('overflow', 'hidden');
		return false;
    });

    $('.js-form__btn').on('click', function(){
		$('.form-inn-add').addClass('form-inn-add--active');
		return false;
    });

    $('.form-inn-add .section-back-btn').on('click', function(){
		$('.form-inn-add').removeClass('form-inn-add--active');
		return false;
    });

    $('.form-inn-add .close').on('click', function(){
		$('.form-inn-add').removeClass('form-inn-add--active');
		return false;
    });

    $('.js-form__label').on('click', function(){
    	$(this).closest('.form__element').find('input').focus();
    });

    $('.form__element input').on('focusout', function() {
		if (this.value !== '') {
			$(this).addClass('focus');
		} else {
			$(this).removeClass('focus');
		}
    });
});


// WEBPACK FOOTER //
// ./src/scripts/form.js